import React from "react";
import { observer, inject } from "mobx-react";

@inject("store")
@observer
export default class PageTitle extends React.Component<{}> {
  // Pages which display the titles
  private pagesUsed = [
    {
      name: "Tactical",
      path: "/tactical",
    },
    {
      name: "Map Editor",
      path: "/mapEditor",
    },
    {
      name: "Strategic",
      path: "/strategic",
    },
    {
      name: "Route",
      path: "/route",
      func: () => (window.location.href = "/dispatch"),
    },
    {
      name: "Dispatch",
      path: "/dispatch",
      func: () => (window.location.href = "/route"),
    },
  ];

  private renderTitle = () => {
    const usedPage = this.pagesUsed.find((pu) => pu.path === window.location.pathname);

    if (usedPage) {
      return (
        <div
          style={usedPage.func ? { cursor: "pointer" } : {}}
          className="pageTitle"
          onDoubleClick={(e) => (usedPage.func ? usedPage.func() : e.preventDefault())}
        >
          <b style={{ marginTop: 2 }}>{usedPage.name}</b>
        </div>
      );
    }

    return null;
  };

  public render() {
    return this.renderTitle();
  }
}
